<template>
	<action-card
		v-if="invoices.length"
		:title="$t('nav.invoices')"
		icon="receipt-text"
		:count="invoices.length"
		@open="$router.push('/invoices?v=list')"
	>
		<button
			v-for="invoice in visibleInvoices"
			:key="invoice.id"
			type="button"
			class="portal-action-row"
			@click="openInvoice(invoice)"
		>
			<span class="action-row-copy">
				<strong>{{ invoice.invoiceNumberFormatted }}</strong>
				<small>
					{{ $formatters.dollars(invoice.total) }} · {{ $t('global.due') }}
					{{ DateTime.fromISO(invoice.dateDue).toFormat('MMM dd') }}
				</small>
			</span>
			<portal-icon name="chevron-right" :size="18"></portal-icon>
		</button>
	</action-card>
</template>

<script>
	import { DateTime } from 'luxon';
	import InvoiceDetails from '@/modules/invoices/InvoiceDetails';
	import ActionCard from '@/modules/welcome/actionItems/ActionCard';

	export default {
		name: 'Invoices',

		props: ['invoices'],

		components: { ActionCard },

		data() {
			return { DateTime };
		},

		methods: {
			openInvoice(invoice) {
				this.$store.state.globalModalController
					.openModal(InvoiceDetails, { invoiceId: invoice.id }, true, false, 'document-lightbox')
					.then(() => this.$emit('refresh'));
			},
		},

		computed: {
			visibleInvoices() {
				return this.invoices.slice(0, 5);
			},
		},
	};
</script>
